const baseTranslateUrl = './assets/i18n';
export const modules = [
  { baseTranslateUrl },
  { baseTranslateUrl, moduleName: 'flt' },
  { baseTranslateUrl, moduleName: 'cs' },
  { baseTranslateUrl, moduleName: 'csei' },
  { baseTranslateUrl, moduleName: 'npt' },
  { baseTranslateUrl, moduleName: 'dq' },
  { baseTranslateUrl, moduleName: 'dashboard' },
  { baseTranslateUrl, moduleName: 'sup' },
  { baseTranslateUrl, moduleName: 'em' },
  { baseTranslateUrl, moduleName: 'alerting' },
  { baseTranslateUrl, moduleName: 'nfc' },
  { baseTranslateUrl, moduleName: 'logging' },
  { baseTranslateUrl, moduleName: 'login' },
  { baseTranslateUrl, moduleName: 'sub-tenants' },
  { baseTranslateUrl, moduleName: 'user' },
  // Team Sherlock
  { baseTranslateUrl, moduleName: 'afb' },
  { baseTranslateUrl, moduleName: 'evdprice' },
  { baseTranslateUrl, moduleName: 'loyalty' },
  { baseTranslateUrl, moduleName: 'price' },
  // add more entries for your libs here
  { baseTranslateUrl, moduleName: 'pgw' },
];
